export const breakpoints = {
  sm: "320px",
  md: "845px", // mobile
  lg: "960px",
  xl: "1200px",
  "2xl": "1536px",
};
